// extracted by css-extract-rspack-plugin
export default {"definitionBox":"dG81Hp0NjrULi6e4","definitionContent":"kSKOjs6_jYrQshBz","definitionDivider":"lPdX5NlCzvgnZIpX","aggLabel":"rKr5NNPtos2u9csX","termRow":"g1JvI9I997cwkWTt"};